import api from "../../apis/siar";

//Querie para obtener la lista de capas que se utilizan en Monitoreo de Fenómenos
const fetchModuleLayersQuery = `query{
  listaCapasMonitoreo{
    registros{
      id
      nombre
      url
      idmodulo
      indice
    }
  }
}`;

//Accion para obtener las capas
export const fetchModuleLayersAction =
  (moduleId) => async (dispatch, getState) => {
    const promise = await api.post("/", {
      query: fetchModuleLayersQuery.replace("@moduleId", moduleId),
    });
    dispatch({
      type: "FETCH_MODULE_LAYERS_CATALOG",
      payload: promise.data.data,
    });
  };
